module.exports = __webpack_public_path__ + "static/media/brown.10039201.svg";